<template>
  <v-form v-model="isFormValid" ref="form">
    <v-row>
      <v-col cols="12">
        <template v-for="(question, questionIndex) in registrationSurveyQuestions">
          <v-text-field
            v-if="question.type === 'text'"
            :key="questionIndex"
            v-model="answers[question.input]"
            outlined
            dense
            :rules="buildRulesForInput(question)"
            :label="question.input"
          ></v-text-field>
          <v-radio-group
            v-if="question.type === 'radiobutton'"
            :key="questionIndex"
            v-model="answers[question.input]"
            :rules="buildRulesForInput(question)"
            row
          >
            <template v-slot:label>
              <span class="subtitle-2 d-block" v-text="question.input"></span>
            </template>

            <template v-slot:default>
              <v-radio
                v-for="(variant, variantIndex) in question.variants"
                :key="`q${questionIndex}-v${variantIndex}`"
                :label="variant"
                :value="variant"
              ></v-radio>
            </template>
          </v-radio-group>
        </template>
      </v-col>
      <v-col cols="12" class="text-right">
        <v-btn :disabled="!isFormValid" color="primary" @click="send" :elevation="0">Продолжить</v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import { required } from '@/utils/rules';

export default {
  name: "RegistrationSurvey",

  data: () => ({
    isFormValid: null,

    answers: {}
  }),

  computed: {
    ...mapState({
      registration_survey: state => state.profile.possible_activity?.registration_form?.registration_survey
    }),

    registrationSurveyQuestions() {
      return this.registration_survey?.questions;
    }
  },

  methods: {
    required,
    mustBeOneOf: (variants) => (v) => {
      if (!v) return 'Необходимо выбрать один из вариантов';
      if (!variants.includes(v)) return 'Необходимо выбрать один из предложенных вариантов';

      return true;
    },

    buildRulesForInput(item) {
      const rules = [];

      if (item.required === true) {
        if (item.type === 'text') {
          rules.push(this.required('Необходимо заполнить'));
        } else if (item.type === 'radiobutton') {
          rules.push(this.required('Необходимо выбрать'));
        }
      }

      if (Array.isArray(item.variants) && item.type === 'radiobutton') {
        rules.push(this.mustBeOneOf(item.variants));
      }

      return rules;
    },

    async send() {
      if (this.$refs.form.validate()) {
        await this.$store.dispatch('profile/updateProfile', {
          leaveStepper: this.$store.getters["profile/reqIsNotFilled"] === false, // FIXME: странное решение, нужно переработать (этот компонент не должен управлять состоянием степпера)
          registration_survey: this.answers
        });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.v-input--selection-controls {
  margin-top: 0;
  margin-bottom: 8px;
}

::v-deep .v-input--radio-group__input .v-label {
  width: 100%;
}
</style>
